// src/pages/DailyLedger/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import DailyLedgerFilters from "./components/DailyLedgerFilters";
import DailyLedgerTable from "./components/DailyLedgerTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const DailyLedger = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.dailyLedger);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Day Book Report",
    removeAfterPrint: true,
  });

  return (
    <div className="p-4">
      <Card
        className="shadow-md rounded-xl mb-4"
        title={
          <Title level={4} style={{ margin: 0 }}>
            Day Book
          </Title>
        }
        extra={
          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
          >
            { !screens.xs && "Print" }
          </Button>
        }
        styles={{
          header: { borderBottom: "none", padding: "12px 16px" },
          body: { padding: 0 },
        }}
      />

      <DailyLedgerFilters messageApi={message} />

      <Card className="shadow-md rounded-xl">
        <DailyLedgerTable />
      </Card>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Day Book Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <DailyLedgerTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default DailyLedger;
